export abstract class ReloadContent {
   public abstract reloadContent();
}

export abstract class UpdatableContent extends ReloadContent {
   public abstract updateNode(id: string, name: string);
}


// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/reload-content.abstract.ts